import React from "react";
import { useDispatch } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import UnauthorizedLayout from "components/UnauthorizedLayout";
import { RouteComponentProps } from "react-router-dom";
import { logout } from "shared/reducer/authentication";
import { useTranslation } from "react-i18next";

interface ILogoutProps extends RouteComponentProps {}

export default function Logout(props: ILogoutProps) {
	const { history } = props;
	const dispatch = useDispatch();
	const { t } = useTranslation();

	React.useEffect(() => {
		dispatch(logout());
		history.push("/");
	}, [dispatch, history]);

	return (
		<UnauthorizedLayout>
			<Grid container justify="center">
				<Grid item xs={12} sm={10} md={8} lg={4} xl={2}>
					<Paper style={{ padding: 24 }}>
						<Typography variant="h4">{t("logout.success")}</Typography>
					</Paper>
				</Grid>
			</Grid>
		</UnauthorizedLayout>
	);
}
